/**
 * Session-dismiss for Bundler checkout discount popup (#bndlr-discount-message).
 * After a shopper clicks "No", suppress the popup for the rest of the browser session.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'tava_bundler_discount_dismissed';
  var BUNDLER_COOKIE = 'bndlr_hide_discount_message';
  var BUNDLER_COOKIE_VALUE = 'hide';
  var HTML_CLASS = 'tava-bundler-popup-dismissed';
  var popupObserver = null;

  /** Injects a tiny CSS guard so dismissed popups stay hidden before JS runs. */
  function ensureDismissStyles() {
    if (document.getElementById('tava-bundler-popup-styles')) return;

    var style = document.createElement('style');
    style.id = 'tava-bundler-popup-styles';
    style.textContent =
      'html.' +
      HTML_CLASS +
      ' #bndlr-discount-message{display:none!important;visibility:hidden!important;pointer-events:none!important;}';
    document.head.appendChild(style);
  }

  /** True when the shopper dismissed the Bundler popup this browser session. */
  function isDismissedForSession() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  /** Sets Bundler's native hide cookie so its script skips displayCartValue. */
  function setBundlerHideCookie() {
    if (window.bndlr && typeof window.bndlr.setCookie === 'function') {
      // exdays = 0 creates a session cookie in Bundler's helper.
      window.bndlr.setCookie(BUNDLER_COOKIE, BUNDLER_COOKIE_VALUE, 0);
      return;
    }

    document.cookie = BUNDLER_COOKIE + '=' + BUNDLER_COOKIE_VALUE + ';path=/';
  }

  /** Hides the popup node when Bundler injects or re-shows it. */
  function hideBundlerPopup() {
    var popup = document.getElementById('bndlr-discount-message');
    if (!popup) return;

    popup.style.setProperty('display', 'none', 'important');
    popup.style.setProperty('visibility', 'hidden', 'important');
    popup.style.setProperty('pointer-events', 'none', 'important');
  }

  /** Applies session dismissal state on load and after the shopper clicks "No". */
  function applySessionDismissal() {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (error) {
      /* ignore private mode / blocked storage */
    }

    setBundlerHideCookie();
    document.documentElement.classList.add(HTML_CLASS);
    hideBundlerPopup();
    startPopupGuard();
  }

  /** Watches for Bundler re-injecting the popup after cart updates or page changes. */
  function startPopupGuard() {
    if (popupObserver) return;

    popupObserver = new MutationObserver(function () {
      if (!isDismissedForSession()) return;
      hideBundlerPopup();
    });

    popupObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  }

  /** Boots listeners and restores dismissal state across navigations. */
  function init() {
    ensureDismissStyles();

    if (isDismissedForSession()) {
      applySessionDismissal();
      return;
    }

    document.addEventListener(
      'click',
      function (event) {
        if (!event.target.closest('.bndlr-message-no')) return;
        applySessionDismissal();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
